function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "dotted-world-map-mobile");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "path205",
  d: "M412.53,107.92v.27h.63v1.68h.23v-1.68H414v-.27Zm1.75,0v2h.27v-1.61l.56,1.61h.22l.52-1.57v1.57h.27v-2h-.34l-.56,1.65-.56-1.65Z"
});

var SvgDottedWorldMapMobile = function SvgDottedWorldMapMobile(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "dotted-world-map-mobile-file",
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip-path"
  }, React.createElement("rect", {
    id: "_Clipping_Path_",
    "data-name": "<Clipping Path>",
    x: 28,
    y: 108.59,
    width: 86.88,
    height: 23.12,
    style: {
      fill: "none"
    }
  })), React.createElement("clipPath", {
    id: "clip-path-4"
  }, React.createElement("polyline", {
    id: "_Clipping_Path_4",
    "data-name": "<Clipping Path>",
    points: "114.88 108.59 114.88 131.71 28 131.71 28 108.59",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  }))), _ref2, React.createElement("g", {
    id: "World-map"
  }, React.createElement("path", {
    d: "M205.67,170.7c.38,0-.4,0,0,0",
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("path", {
    d: "M297.32,207.1h0",
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("path", {
    d: "M125.57,183.57a8,8,0,0,1-2.34,0",
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("path", {
    d: "M206,196.45c0-.08,0-.08,0,0",
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 209.14,
    y1: 170.7,
    x2: 209.14,
    y2: 170.7,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 135.05,
    y1: 170.7,
    x2: 155.16,
    y2: 170.7,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 199.22,
    y1: 170.7,
    x2: 205.67,
    y2: 170.7,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 196.31,
    y1: 170.7,
    x2: 179.56,
    y2: 170.7,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 165.39,
    y1: 173.92,
    x2: 168.2,
    y2: 173.92,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 170.41,
    y1: 173.92,
    x2: 173.9,
    y2: 173.92,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 137.58,
    y1: 173.92,
    x2: 139.37,
    y2: 173.92,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 152.83,
    y1: 173.92,
    x2: 140.63,
    y2: 173.92,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 195.32,
    y1: 173.92,
    x2: 175.2,
    y2: 173.92,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 208.1,
    y1: 173.92,
    x2: 205.13,
    y2: 173.92,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 219.92,
    y1: 173.92,
    x2: 215.09,
    y2: 173.92,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 201.72,
    y1: 173.92,
    x2: 202.87,
    y2: 173.92,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 123.13,
    y1: 173.92,
    x2: 129.34,
    y2: 173.92,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 122.07,
    y1: 177.14,
    x2: 125.21,
    y2: 177.14,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 306.22,
    y1: 177.14,
    x2: 302.87,
    y2: 177.14,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 298.72,
    y1: 177.14,
    x2: 291.16,
    y2: 177.14,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 355.69,
    y1: 177.14,
    x2: 349.11,
    y2: 177.14,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 312.07,
    y1: 177.14,
    x2: 308.92,
    y2: 177.14,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 212.83,
    y1: 177.14,
    x2: 153.8,
    y2: 177.14,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 140.41,
    y1: 177.14,
    x2: 148,
    y2: 177.14,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 129.82,
    y1: 177.14,
    x2: 132.96,
    y2: 177.14,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 363.63,
    y1: 180.35,
    x2: 361.02,
    y2: 180.35,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 350.64,
    y1: 180.35,
    x2: 356.52,
    y2: 180.35,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 122.96,
    y1: 180.35,
    x2: 130.1,
    y2: 180.35,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 213.12,
    y1: 180.35,
    x2: 153.76,
    y2: 180.35,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 147.86,
    y1: 180.35,
    x2: 145.15,
    y2: 180.35,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 140.37,
    y1: 180.35,
    x2: 134.81,
    y2: 180.35,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 251.84,
    y1: 180.35,
    x2: 248.73,
    y2: 180.35,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 106.88,
    y1: 180.35,
    x2: 111.04,
    y2: 180.35,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 268.52,
    y1: 180.35,
    x2: 260.12,
    y2: 180.35,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 257.36,
    y1: 183.57,
    x2: 256.06,
    y2: 183.57,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 260.18,
    y1: 183.57,
    x2: 266.82,
    y2: 183.57,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 114.04,
    y1: 183.57,
    x2: 106.48,
    y2: 183.57,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 128.61,
    y1: 183.57,
    x2: 132.47,
    y2: 183.57,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 101.63,
    y1: 183.57,
    x2: 97.04,
    y2: 183.57,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 151.25,
    y1: 183.57,
    x2: 209.51,
    y2: 183.57,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 142.94,
    y1: 183.57,
    x2: 134.66,
    y2: 183.57,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 125.57,
    y1: 183.57,
    x2: 123.23,
    y2: 183.57,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 358.86,
    y1: 183.57,
    x2: 364.54,
    y2: 183.57,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 116.41,
    y1: 183.57,
    x2: 118.06,
    y2: 183.57,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 112.02,
    y1: 186.79,
    x2: 110.74,
    y2: 186.79,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 257.36,
    y1: 186.79,
    x2: 253.03,
    y2: 186.79,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 115.6,
    y1: 186.79,
    x2: 113.35,
    y2: 186.79,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 364.93,
    y1: 186.79,
    x2: 360.24,
    y2: 186.79,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 100.99,
    y1: 186.79,
    x2: 98.43,
    y2: 186.79,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 85.98,
    y1: 186.79,
    x2: 92.22,
    y2: 186.79,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 126.22,
    y1: 186.79,
    x2: 138.84,
    y2: 186.79,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 265.76,
    y1: 186.79,
    x2: 261.39,
    y2: 186.79,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 150.71,
    y1: 186.79,
    x2: 211.07,
    y2: 186.79,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 367.66,
    y1: 190.01,
    x2: 349.87,
    y2: 190.01,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 115.2,
    y1: 190.01,
    x2: 111.88,
    y2: 190.01,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 98.11,
    y1: 190.01,
    x2: 92.62,
    y2: 190.01,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 311.6,
    y1: 190.01,
    x2: 319,
    y2: 190.01,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 212.03,
    y1: 190.01,
    x2: 213.39,
    y2: 190.01,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 104.82,
    y1: 190.01,
    x2: 100.84,
    y2: 190.01,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 160.52,
    y1: 190.01,
    x2: 210.22,
    y2: 190.01,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 121,
    y1: 190.01,
    x2: 137.72,
    y2: 190.01,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 85.38,
    y1: 190.01,
    x2: 90.74,
    y2: 190.01,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 107.72,
    y1: 190.01,
    x2: 109.66,
    y2: 190.01,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 164.32,
    y1: 193.23,
    x2: 211.84,
    y2: 193.23,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 307.45,
    y1: 193.23,
    x2: 314.79,
    y2: 193.23,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 117.73,
    y1: 193.23,
    x2: 121.33,
    y2: 193.23,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 367.23,
    y1: 193.23,
    x2: 342.38,
    y2: 193.23,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 104.87,
    y1: 193.23,
    x2: 95.89,
    y2: 193.23,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 420.68,
    y1: 193.23,
    x2: 416.48,
    y2: 193.23,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 137.98,
    y1: 193.23,
    x2: 123.38,
    y2: 193.23,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 404.67,
    y1: 193.23,
    x2: 410.47,
    y2: 193.23,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 38.87,
    y1: 196.45,
    x2: 67.59,
    y2: 196.45,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 165.76,
    y1: 196.45,
    x2: 205.98,
    y2: 196.45,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 407.75,
    y1: 196.45,
    x2: 412.29,
    y2: 196.45,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 303.72,
    y1: 196.45,
    x2: 311.33,
    y2: 196.45,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 210.96,
    y1: 196.45,
    x2: 208.1,
    y2: 196.45,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 119.85,
    y1: 196.45,
    x2: 124.87,
    y2: 196.45,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 129.59,
    y1: 196.45,
    x2: 132.1,
    y2: 196.45,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 366.26,
    y1: 196.45,
    x2: 335.27,
    y2: 196.45,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 94.1,
    y1: 196.45,
    x2: 81.62,
    y2: 196.45,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 140.24,
    y1: 196.45,
    x2: 136.84,
    y2: 196.45,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 107.49,
    y1: 196.45,
    x2: 104.93,
    y2: 196.45,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 370.58,
    y1: 196.45,
    x2: 372.89,
    y2: 196.45,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 114.81,
    y1: 196.45,
    x2: 110.76,
    y2: 196.45,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 34.49,
    y1: 199.66,
    x2: 72.77,
    y2: 199.66,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 373.74,
    y1: 199.66,
    x2: 335.86,
    y2: 199.66,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 329.26,
    y1: 199.66,
    x2: 326.61,
    y2: 199.66,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 308.68,
    y1: 199.66,
    x2: 299.24,
    y2: 199.66,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 330.16,
    y1: 199.66,
    x2: 332.6,
    y2: 199.66,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 166.57,
    y1: 199.66,
    x2: 206.24,
    y2: 199.66,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 98.52,
    y1: 199.66,
    x2: 81.01,
    y2: 199.66,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 119.94,
    y1: 199.66,
    x2: 123.01,
    y2: 199.66,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 132.31,
    y1: 199.66,
    x2: 129.75,
    y2: 199.66,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 325.7,
    y1: 199.66,
    x2: 320.62,
    y2: 199.66,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 116.7,
    y1: 199.66,
    x2: 110.65,
    y2: 199.66,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 109.42,
    y1: 199.66,
    x2: 103.56,
    y2: 199.66,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 208.41,
    y1: 199.66,
    x2: 208.41,
    y2: 199.66,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 411.7,
    y1: 199.66,
    x2: 406.27,
    y2: 199.66,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 101.11,
    y1: 199.66,
    x2: 102.19,
    y2: 199.66,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 405.26,
    y1: 202.88,
    x2: 421.63,
    y2: 202.88,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 203.28,
    y1: 202.88,
    x2: 171.73,
    y2: 202.88,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 32.32,
    y1: 202.88,
    x2: 75.77,
    y2: 202.88,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 331.55,
    y1: 202.88,
    x2: 320.87,
    y2: 202.88,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 375.79,
    y1: 202.88,
    x2: 332.21,
    y2: 202.88,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 209.04,
    y1: 202.88,
    x2: 204.51,
    y2: 202.88,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 128.65,
    y1: 202.88,
    x2: 148.07,
    y2: 202.88,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 306.56,
    y1: 202.88,
    x2: 299.58,
    y2: 202.88,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 119.23,
    y1: 202.88,
    x2: 120.69,
    y2: 202.88,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 456.36,
    y1: 202.88,
    x2: 459.84,
    y2: 202.88,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 111.54,
    y1: 202.88,
    x2: 91.44,
    y2: 202.88,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 114.59,
    y1: 206.1,
    x2: 116.62,
    y2: 206.1,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 321.03,
    y1: 206.1,
    x2: 323.88,
    y2: 206.1,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 31.44,
    y1: 206.1,
    x2: 75.39,
    y2: 206.1,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 132.74,
    y1: 206.1,
    x2: 132.28,
    y2: 206.1,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 119.8,
    y1: 206.1,
    x2: 123.38,
    y2: 206.1,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 204.79,
    y1: 206.1,
    x2: 169.87,
    y2: 206.1,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 443.54,
    y1: 206.1,
    x2: 438.97,
    y2: 206.1,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 138.22,
    y1: 206.1,
    x2: 153.88,
    y2: 206.1,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 430.07,
    y1: 206.1,
    x2: 326.9,
    y2: 206.1,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 309.08,
    y1: 206.1,
    x2: 312.6,
    y2: 206.1,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 111.43,
    y1: 206.1,
    x2: 90.98,
    y2: 206.1,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 257.47,
    y1: 206.1,
    x2: 260.4,
    y2: 206.1,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 277.41,
    y1: 206.1,
    x2: 279.41,
    y2: 206.1,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 262.67,
    y1: 206.1,
    x2: 273.89,
    y2: 206.1,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 168.67,
    y1: 209.32,
    x2: 195.63,
    y2: 209.32,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 81.4,
    y1: 209.32,
    x2: 95.92,
    y2: 209.32,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 153.34,
    y1: 209.32,
    x2: 137.94,
    y2: 209.32,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 131.64,
    y1: 209.32,
    x2: 132.15,
    y2: 209.32,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 297.63,
    y1: 209.32,
    x2: 320.47,
    y2: 209.32,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 251.42,
    y1: 209.32,
    x2: 254.49,
    y2: 209.32,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 277.05,
    y1: 209.32,
    x2: 256.13,
    y2: 209.32,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 292.89,
    y1: 209.32,
    x2: 289.14,
    y2: 209.32,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 117.25,
    y1: 209.32,
    x2: 112.51,
    y2: 209.32,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 447.53,
    y1: 209.32,
    x2: 328.1,
    y2: 209.32,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 31.5,
    y1: 209.32,
    x2: 74.55,
    y2: 209.32,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 126.04,
    y1: 209.32,
    x2: 121.05,
    y2: 209.32,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 131.54,
    y1: 212.54,
    x2: 104.82,
    y2: 212.54,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 255.19,
    y1: 212.54,
    x2: 275.7,
    y2: 212.54,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 320.26,
    y1: 212.54,
    x2: 290.57,
    y2: 212.54,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 327.86,
    y1: 212.54,
    x2: 457.66,
    y2: 212.54,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 97.87,
    y1: 212.54,
    x2: 36.65,
    y2: 212.54,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 138.4,
    y1: 212.54,
    x2: 161.02,
    y2: 212.54,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 467.27,
    y1: 212.54,
    x2: 463.69,
    y2: 212.54,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 170.97,
    y1: 212.54,
    x2: 191.52,
    y2: 212.54,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 206.25,
    y1: 215.76,
    x2: 219.14,
    y2: 215.76,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 139.4,
    y1: 215.76,
    x2: 152.34,
    y2: 215.76,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 266.71,
    y1: 215.76,
    x2: 278.4,
    y2: 215.76,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 468.56,
    y1: 215.76,
    x2: 459.05,
    y2: 215.76,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 252.65,
    y1: 215.76,
    x2: 262.73,
    y2: 215.76,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 131.6,
    y1: 215.76,
    x2: 37.79,
    y2: 215.76,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 189.13,
    y1: 215.76,
    x2: 171.93,
    y2: 215.76,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 453.22,
    y1: 215.76,
    x2: 284.71,
    y2: 215.76,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 282.18,
    y1: 218.97,
    x2: 268.68,
    y2: 218.97,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 245.93,
    y1: 218.97,
    x2: 259.83,
    y2: 218.97,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 174.81,
    y1: 218.97,
    x2: 186.63,
    y2: 218.97,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 205.82,
    y1: 218.97,
    x2: 217.32,
    y2: 218.97,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 453.73,
    y1: 218.97,
    x2: 282.73,
    y2: 218.97,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 39,
    y1: 218.97,
    x2: 120.61,
    y2: 218.97,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 129.28,
    y1: 218.97,
    x2: 136.52,
    y2: 218.97,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 151.16,
    y1: 218.97,
    x2: 140.34,
    y2: 218.97,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 153.85,
    y1: 218.97,
    x2: 155.19,
    y2: 218.97,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 141.87,
    y1: 222.19,
    x2: 154.33,
    y2: 222.19,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 455.84,
    y1: 222.19,
    x2: 439.12,
    y2: 222.19,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 37.21,
    y1: 222.19,
    x2: 124.63,
    y2: 222.19,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 183.08,
    y1: 222.19,
    x2: 175.55,
    y2: 222.19,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 436.2,
    y1: 222.19,
    x2: 270.44,
    y2: 222.19,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 258.38,
    y1: 222.19,
    x2: 242.89,
    y2: 222.19,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 428.04,
    y1: 225.41,
    x2: 272.19,
    y2: 225.41,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 153.94,
    y1: 225.41,
    x2: 139.32,
    y2: 225.41,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 241.93,
    y1: 225.41,
    x2: 257.61,
    y2: 225.41,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 447.79,
    y1: 225.41,
    x2: 438.75,
    y2: 225.41,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 124.93,
    y1: 225.41,
    x2: 53.95,
    y2: 225.41,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 38.97,
    y1: 225.41,
    x2: 48.11,
    y2: 225.41,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 442.12,
    y1: 228.63,
    x2: 435.44,
    y2: 228.63,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 257.26,
    y1: 228.63,
    x2: 249.57,
    y2: 228.63,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 412.66,
    y1: 228.63,
    x2: 268.75,
    y2: 228.63,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 38.32,
    y1: 228.63,
    x2: 45.12,
    y2: 228.63,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 55.24,
    y1: 228.63,
    x2: 125.23,
    y2: 228.63,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 425.86,
    y1: 228.63,
    x2: 418.04,
    y2: 228.63,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 162.28,
    y1: 228.63,
    x2: 139.07,
    y2: 228.63,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 437.08,
    y1: 231.85,
    x2: 431.15,
    y2: 231.85,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 246.83,
    y1: 231.85,
    x2: 248.81,
    y2: 231.85,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 228.85,
    y1: 231.85,
    x2: 233.58,
    y2: 231.85,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 250.41,
    y1: 231.85,
    x2: 257.16,
    y2: 231.85,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 138.97,
    y1: 231.85,
    x2: 164.58,
    y2: 231.85,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 264.22,
    y1: 231.85,
    x2: 261.66,
    y2: 231.85,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 405.15,
    y1: 231.85,
    x2: 266.11,
    y2: 231.85,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 35.09,
    y1: 231.85,
    x2: 42.47,
    y2: 231.85,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 126.05,
    y1: 231.85,
    x2: 58.62,
    y2: 231.85,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 401.71,
    y1: 235.07,
    x2: 260.46,
    y2: 235.07,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 64.36,
    y1: 235.07,
    x2: 129.52,
    y2: 235.07,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 251.37,
    y1: 235.07,
    x2: 246.81,
    y2: 235.07,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 435.78,
    y1: 235.07,
    x2: 427.35,
    y2: 235.07,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 255.61,
    y1: 235.07,
    x2: 253.87,
    y2: 235.07,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 138.53,
    y1: 235.07,
    x2: 165.43,
    y2: 235.07,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 231.89,
    y1: 235.07,
    x2: 227.87,
    y2: 235.07,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 32.97,
    y1: 235.07,
    x2: 39.74,
    y2: 235.07,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 229.61,
    y1: 238.29,
    x2: 232.94,
    y2: 238.29,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 162,
    y1: 238.29,
    x2: 137.39,
    y2: 238.29,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 224.64,
    y1: 238.29,
    x2: 227.13,
    y2: 238.29,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 402.82,
    y1: 238.29,
    x2: 257.68,
    y2: 238.29,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 410.45,
    y1: 238.29,
    x2: 413.56,
    y2: 238.29,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 246.88,
    y1: 238.29,
    x2: 249.75,
    y2: 238.29,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 72.25,
    y1: 238.29,
    x2: 132.12,
    y2: 238.29,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 433.73,
    y1: 238.29,
    x2: 425.29,
    y2: 238.29,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 408.8,
    y1: 241.5,
    x2: 415.41,
    y2: 241.5,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 223.11,
    y1: 241.5,
    x2: 225.95,
    y2: 241.5,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 162.18,
    y1: 241.5,
    x2: 80.71,
    y2: 241.5,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 234.59,
    y1: 241.5,
    x2: 228.66,
    y2: 241.5,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 406.35,
    y1: 241.5,
    x2: 243.83,
    y2: 241.5,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 431.02,
    y1: 241.5,
    x2: 426.04,
    y2: 241.5,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 77.73,
    y1: 244.72,
    x2: 80.69,
    y2: 244.72,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 406.41,
    y1: 244.72,
    x2: 235.6,
    y2: 244.72,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 162.41,
    y1: 244.72,
    x2: 86.42,
    y2: 244.72,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 229.24,
    y1: 244.72,
    x2: 233.01,
    y2: 244.72,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 415.32,
    y1: 244.72,
    x2: 409.8,
    y2: 244.72,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 165.52,
    y1: 244.72,
    x2: 168.46,
    y2: 244.72,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 414.35,
    y1: 247.94,
    x2: 409.18,
    y2: 247.94,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 405.24,
    y1: 247.94,
    x2: 229.93,
    y2: 247.94,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 77.15,
    y1: 247.94,
    x2: 82.55,
    y2: 247.94,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 147.94,
    y1: 247.94,
    x2: 86.75,
    y2: 247.94,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 161.37,
    y1: 247.94,
    x2: 149.16,
    y2: 247.94,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 164.9,
    y1: 247.94,
    x2: 170.58,
    y2: 247.94,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 77.74,
    y1: 251.16,
    x2: 162.28,
    y2: 251.16,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 412.44,
    y1: 251.16,
    x2: 409.14,
    y2: 251.16,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 404.15,
    y1: 251.16,
    x2: 232.72,
    y2: 251.16,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 255.04,
    y1: 254.38,
    x2: 402.62,
    y2: 254.38,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 251.48,
    y1: 254.38,
    x2: 234.39,
    y2: 254.38,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 79.06,
    y1: 254.38,
    x2: 159.97,
    y2: 254.38,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 416.98,
    y1: 254.38,
    x2: 408.31,
    y2: 254.38,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 257.77,
    y1: 257.6,
    x2: 396.32,
    y2: 257.6,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 80.84,
    y1: 257.6,
    x2: 153.19,
    y2: 257.6,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 255.42,
    y1: 257.6,
    x2: 249.82,
    y2: 257.6,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 239.11,
    y1: 257.6,
    x2: 224.35,
    y2: 257.6,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 260.14,
    y1: 260.81,
    x2: 263.14,
    y2: 260.81,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 236.38,
    y1: 260.81,
    x2: 224.25,
    y2: 260.81,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 82.87,
    y1: 260.81,
    x2: 145.31,
    y2: 260.81,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 407.87,
    y1: 260.81,
    x2: 406.02,
    y2: 260.81,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 267.11,
    y1: 260.81,
    x2: 383.52,
    y2: 260.81,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 394.48,
    y1: 260.81,
    x2: 385.43,
    y2: 260.81,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 262.67,
    y1: 264.03,
    x2: 257.16,
    y2: 264.03,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 233.7,
    y1: 264.03,
    x2: 225.78,
    y2: 264.03,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 393.93,
    y1: 264.03,
    x2: 386.68,
    y2: 264.03,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 268.18,
    y1: 264.03,
    x2: 380.34,
    y2: 264.03,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 250.94,
    y1: 264.03,
    x2: 254.08,
    y2: 264.03,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 84.92,
    y1: 264.03,
    x2: 141.28,
    y2: 264.03,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 407.62,
    y1: 264.03,
    x2: 404.6,
    y2: 264.03,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 403.38,
    y1: 267.25,
    x2: 399.57,
    y2: 267.25,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 385.93,
    y1: 267.25,
    x2: 273.7,
    y2: 267.25,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 86.78,
    y1: 267.25,
    x2: 140.69,
    y2: 267.25,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 393.6,
    y1: 267.25,
    x2: 388.32,
    y2: 267.25,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 250.87,
    y1: 267.25,
    x2: 236.2,
    y2: 267.25,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 252.02,
    y1: 270.47,
    x2: 221.55,
    y2: 270.47,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 88.25,
    y1: 270.47,
    x2: 140.99,
    y2: 270.47,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 273.75,
    y1: 270.47,
    x2: 385.48,
    y2: 270.47,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 100.94,
    y1: 273.69,
    x2: 141.56,
    y2: 273.69,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 89.66,
    y1: 273.69,
    x2: 94.5,
    y2: 273.69,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 257.27,
    y1: 273.69,
    x2: 272.09,
    y2: 273.69,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 273.87,
    y1: 273.69,
    x2: 384.93,
    y2: 273.69,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 254.11,
    y1: 273.69,
    x2: 217.64,
    y2: 273.69,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 91.15,
    y1: 276.91,
    x2: 94.91,
    y2: 276.91,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 384.29,
    y1: 276.91,
    x2: 302.77,
    y2: 276.91,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 126.03,
    y1: 276.91,
    x2: 141.85,
    y2: 276.91,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 120.53,
    y1: 276.91,
    x2: 103.29,
    y2: 276.91,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 294.48,
    y1: 276.91,
    x2: 215.75,
    y2: 276.91,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 92.83,
    y1: 280.12,
    x2: 97.46,
    y2: 280.12,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 116.58,
    y1: 280.12,
    x2: 105.03,
    y2: 280.12,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 383.35,
    y1: 280.12,
    x2: 312,
    y2: 280.12,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 297.25,
    y1: 280.12,
    x2: 214.7,
    y2: 280.12,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 129.43,
    y1: 280.12,
    x2: 140.94,
    y2: 280.12,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 380.75,
    y1: 283.34,
    x2: 318.86,
    y2: 283.34,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 94.89,
    y1: 283.34,
    x2: 100.24,
    y2: 283.34,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 299.04,
    y1: 283.34,
    x2: 214.14,
    y2: 283.34,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 122.09,
    y1: 283.34,
    x2: 106.64,
    y2: 283.34,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 213.87,
    y1: 286.56,
    x2: 309.58,
    y2: 286.56,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 384.2,
    y1: 286.56,
    x2: 382.74,
    y2: 286.56,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 127.46,
    y1: 286.56,
    x2: 108.33,
    y2: 286.56,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 372.46,
    y1: 286.56,
    x2: 378.36,
    y2: 286.56,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 367.96,
    y1: 286.56,
    x2: 321.92,
    y2: 286.56,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 131.71,
    y1: 286.56,
    x2: 138.79,
    y2: 286.56,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 307.24,
    y1: 289.78,
    x2: 213.8,
    y2: 289.78,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 340.21,
    y1: 289.78,
    x2: 323.36,
    y2: 289.78,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 147.21,
    y1: 289.78,
    x2: 153.63,
    y2: 289.78,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 347.98,
    y1: 289.78,
    x2: 367.07,
    y2: 289.78,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 144.43,
    y1: 289.78,
    x2: 141.96,
    y2: 289.78,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 110.28,
    y1: 289.78,
    x2: 129.15,
    y2: 289.78,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 375.59,
    y1: 289.78,
    x2: 369.74,
    y2: 289.78,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 337.51,
    y1: 293,
    x2: 325,
    y2: 293,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 367.29,
    y1: 293,
    x2: 350.76,
    y2: 293,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 112.87,
    y1: 293,
    x2: 127,
    y2: 293,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 385.71,
    y1: 293,
    x2: 383.2,
    y2: 293,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 146.85,
    y1: 293,
    x2: 155.67,
    y2: 293,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 214.88,
    y1: 293,
    x2: 303.63,
    y2: 293,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 335.84,
    y1: 296.22,
    x2: 326.77,
    y2: 296.22,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 368.31,
    y1: 296.22,
    x2: 356.04,
    y2: 296.22,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 385.66,
    y1: 296.22,
    x2: 382.39,
    y2: 296.22,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 216.24,
    y1: 296.22,
    x2: 299.25,
    y2: 296.22,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 117.4,
    y1: 296.22,
    x2: 128.08,
    y2: 296.22,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 328.76,
    y1: 299.44,
    x2: 334.56,
    y2: 299.44,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 389.73,
    y1: 299.44,
    x2: 383.68,
    y2: 299.44,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 121.94,
    y1: 299.44,
    x2: 141.69,
    y2: 299.44,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 360.84,
    y1: 299.44,
    x2: 369.32,
    y2: 299.44,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 217.72,
    y1: 299.44,
    x2: 296.28,
    y2: 299.44,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 126.39,
    y1: 302.65,
    x2: 160.36,
    y2: 302.65,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 379.53,
    y1: 302.65,
    x2: 382.95,
    y2: 302.65,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 387.75,
    y1: 302.65,
    x2: 385.25,
    y2: 302.65,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 369.74,
    y1: 302.65,
    x2: 362.08,
    y2: 302.65,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 331.34,
    y1: 302.65,
    x2: 333.47,
    y2: 302.65,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 219.32,
    y1: 302.65,
    x2: 298.71,
    y2: 302.65,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 390.83,
    y1: 305.87,
    x2: 385.71,
    y2: 305.87,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 221.11,
    y1: 305.87,
    x2: 298.89,
    y2: 305.87,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 364.25,
    y1: 305.87,
    x2: 366.13,
    y2: 305.87,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 132.7,
    y1: 305.87,
    x2: 164.34,
    y2: 305.87,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 333.56,
    y1: 305.87,
    x2: 336.35,
    y2: 305.87,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 246.79,
    y1: 309.09,
    x2: 296.77,
    y2: 309.09,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 359.85,
    y1: 309.09,
    x2: 362.11,
    y2: 309.09,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 382.49,
    y1: 309.09,
    x2: 378.94,
    y2: 309.09,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 137.87,
    y1: 309.09,
    x2: 167.18,
    y2: 309.09,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 390.25,
    y1: 309.09,
    x2: 388.66,
    y2: 309.09,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 235.22,
    y1: 309.09,
    x2: 223.7,
    y2: 309.09,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 355,
    y1: 312.31,
    x2: 359.12,
    y2: 312.31,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 381.29,
    y1: 312.31,
    x2: 372.46,
    y2: 312.31,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 248.5,
    y1: 312.31,
    x2: 293.15,
    y2: 312.31,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 137.4,
    y1: 312.31,
    x2: 169.56,
    y2: 312.31,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 363.63,
    y1: 312.31,
    x2: 360.86,
    y2: 312.31,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 391.01,
    y1: 315.53,
    x2: 394.04,
    y2: 315.53,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 369.46,
    y1: 315.53,
    x2: 381.75,
    y2: 315.53,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 356.72,
    y1: 315.53,
    x2: 362.17,
    y2: 315.53,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 249.13,
    y1: 315.53,
    x2: 289.24,
    y2: 315.53,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 137.34,
    y1: 315.53,
    x2: 171.67,
    y2: 315.53,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 286.27,
    y1: 318.75,
    x2: 249.54,
    y2: 318.75,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 405.76,
    y1: 318.75,
    x2: 397.28,
    y2: 318.75,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 380.25,
    y1: 318.75,
    x2: 370.17,
    y2: 318.75,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 358.88,
    y1: 318.75,
    x2: 364.58,
    y2: 318.75,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 137.66,
    y1: 318.75,
    x2: 175.48,
    y2: 318.75,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 384.79,
    y1: 318.75,
    x2: 382.13,
    y2: 318.75,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 386.51,
    y1: 321.96,
    x2: 384.56,
    y2: 321.96,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 284.78,
    y1: 321.96,
    x2: 249.84,
    y2: 321.96,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 381.63,
    y1: 321.96,
    x2: 383.63,
    y2: 321.96,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 365.16,
    y1: 321.96,
    x2: 362.08,
    y2: 321.96,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 139.36,
    y1: 321.96,
    x2: 183.5,
    y2: 321.96,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 403.16,
    y1: 321.96,
    x2: 414.88,
    y2: 321.96,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 284.66,
    y1: 325.18,
    x2: 250.08,
    y2: 325.18,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 404.75,
    y1: 325.18,
    x2: 419.24,
    y2: 325.18,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 141.36,
    y1: 325.18,
    x2: 189.55,
    y2: 325.18,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 365.25,
    y1: 325.18,
    x2: 375.94,
    y2: 325.18,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 420.9,
    y1: 328.4,
    x2: 408.18,
    y2: 328.4,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 143.44,
    y1: 328.4,
    x2: 193.11,
    y2: 328.4,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 285.18,
    y1: 328.4,
    x2: 250.28,
    y2: 328.4,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 369.2,
    y1: 328.4,
    x2: 377.52,
    y2: 328.4,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 388.35,
    y1: 328.4,
    x2: 391.36,
    y2: 328.4,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 383.52,
    y1: 328.4,
    x2: 385.71,
    y2: 328.4,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 145.45,
    y1: 331.62,
    x2: 192.41,
    y2: 331.62,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 403.09,
    y1: 331.62,
    x2: 397.76,
    y2: 331.62,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 285.52,
    y1: 331.62,
    x2: 250.47,
    y2: 331.62,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 285.25,
    y1: 334.84,
    x2: 250.67,
    y2: 334.84,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 147.2,
    y1: 334.84,
    x2: 187.45,
    y2: 334.84,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 406.1,
    y1: 334.84,
    x2: 396.05,
    y2: 334.84,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 297.25,
    y1: 334.84,
    x2: 293.59,
    y2: 334.84,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 413.57,
    y1: 334.84,
    x2: 408.47,
    y2: 334.84,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 297.11,
    y1: 338.06,
    x2: 291.69,
    y2: 338.06,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 413.23,
    y1: 338.06,
    x2: 387.86,
    y2: 338.06,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 148.53,
    y1: 338.06,
    x2: 185.96,
    y2: 338.06,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 284.08,
    y1: 338.06,
    x2: 250.9,
    y2: 338.06,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 296.84,
    y1: 341.27,
    x2: 290.35,
    y2: 341.27,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 149.3,
    y1: 341.27,
    x2: 184.54,
    y2: 341.27,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 416.2,
    y1: 341.27,
    x2: 384.8,
    y2: 341.27,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 251.22,
    y1: 341.27,
    x2: 282.82,
    y2: 341.27,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 289.39,
    y1: 344.49,
    x2: 296.26,
    y2: 344.49,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 251.76,
    y1: 344.49,
    x2: 281.47,
    y2: 344.49,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 418.92,
    y1: 344.49,
    x2: 378.2,
    y2: 344.49,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 440.02,
    y1: 344.49,
    x2: 436.81,
    y2: 344.49,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 149.44,
    y1: 344.49,
    x2: 183.11,
    y2: 344.49,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 294.23,
    y1: 347.71,
    x2: 288.88,
    y2: 347.71,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 149,
    y1: 347.71,
    x2: 181.62,
    y2: 347.71,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 279.91,
    y1: 347.71,
    x2: 252.49,
    y2: 347.71,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 421.25,
    y1: 347.71,
    x2: 375.49,
    y2: 347.71,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 423.03,
    y1: 350.93,
    x2: 376.2,
    y2: 350.93,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 148.53,
    y1: 350.93,
    x2: 180.03,
    y2: 350.93,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 275.69,
    y1: 350.93,
    x2: 253.41,
    y2: 350.93,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 274.47,
    y1: 354.15,
    x2: 254.57,
    y2: 354.15,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 424.05,
    y1: 354.15,
    x2: 373.93,
    y2: 354.15,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 148.06,
    y1: 354.15,
    x2: 178.26,
    y2: 354.15,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 147.6,
    y1: 357.37,
    x2: 176.03,
    y2: 357.37,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 256.06,
    y1: 357.37,
    x2: 273.16,
    y2: 357.37,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 424.1,
    y1: 357.37,
    x2: 374.64,
    y2: 357.37,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 258.12,
    y1: 360.58,
    x2: 271.25,
    y2: 360.58,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 405.42,
    y1: 360.58,
    x2: 421.8,
    y2: 360.58,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 147.15,
    y1: 360.58,
    x2: 166.95,
    y2: 360.58,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 375.91,
    y1: 360.58,
    x2: 400.42,
    y2: 360.58,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 390.56,
    y1: 363.8,
    x2: 377.05,
    y2: 363.8,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 410.65,
    y1: 363.8,
    x2: 418.38,
    y2: 363.8,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 146.69,
    y1: 363.8,
    x2: 163.63,
    y2: 363.8,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 146.24,
    y1: 367.02,
    x2: 161.54,
    y2: 367.02,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 414.04,
    y1: 367.02,
    x2: 414.8,
    y2: 367.02,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 454.02,
    y1: 367.02,
    x2: 449.63,
    y2: 367.02,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 145.78,
    y1: 370.24,
    x2: 160.88,
    y2: 370.24,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 454.41,
    y1: 370.24,
    x2: 449.24,
    y2: 370.24,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 417.87,
    y1: 373.46,
    x2: 413.23,
    y2: 373.46,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 145.32,
    y1: 373.46,
    x2: 155.69,
    y2: 373.46,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 448.72,
    y1: 376.68,
    x2: 443.42,
    y2: 376.68,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 156.94,
    y1: 376.68,
    x2: 147.74,
    y2: 376.68,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 417.09,
    y1: 376.68,
    x2: 414.72,
    y2: 376.68,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 446.36,
    y1: 379.9,
    x2: 440.26,
    y2: 379.9,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 154.84,
    y1: 379.9,
    x2: 146.56,
    y2: 379.9,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 155.23,
    y1: 383.11,
    x2: 144.03,
    y2: 383.11,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 156.2,
    y1: 386.33,
    x2: 144.89,
    y2: 386.33,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 145.07,
    y1: 389.55,
    x2: 157.17,
    y2: 389.55,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 146.28,
    y1: 392.77,
    x2: 157.75,
    y2: 392.77,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  }), React.createElement("line", {
    x1: 148.48,
    y1: 395.99,
    x2: 156.14,
    y2: 395.99,
    style: {
      fill: "none",
      stroke: "#dae1e7",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.10853599507432px",
      strokeDasharray: "0,3.162813663482666"
    }
  })), React.createElement("g", {
    id: "Icons"
  }, React.createElement("g", {
    id: "Paypal"
  }, React.createElement("g", {
    id: "_Group_5",
    "data-name": "<Group>"
  }, React.createElement("g", {
    id: "_Group_6",
    "data-name": "<Group>"
  }, React.createElement("g", {
    id: "_Group_7",
    "data-name": "<Group>"
  }, React.createElement("g", {
    id: "_Group_8",
    "data-name": "<Group>"
  }, React.createElement("path", {
    id: "_Compound_Path_",
    "data-name": "<Compound Path>",
    d: "M60.93,117.81c-.26,1.72-1.58,1.72-2.85,1.72h-.72l.51-3.21a.4.4,0,0,1,.39-.34h.33c.87,0,1.68,0,2.11.49A1.64,1.64,0,0,1,60.93,117.81Zm-.55-4.49h-4.8a.66.66,0,0,0-.65.56L53,126.17a.4.4,0,0,0,.39.46h2.29a.67.67,0,0,0,.66-.56l.52-3.31a.67.67,0,0,1,.66-.57H59q4.72,0,5.45-4.55a3.69,3.69,0,0,0-.61-3.09A4.45,4.45,0,0,0,60.38,113.32Z",
    style: {
      fill: "#253b80"
    }
  }), React.createElement("path", {
    id: "_Compound_Path_2",
    "data-name": "<Compound Path>",
    d: "M71.5,122.22a2.56,2.56,0,0,1-2.59,2.19,1.91,1.91,0,0,1-1.54-.62,1.93,1.93,0,0,1-.36-1.61A2.58,2.58,0,0,1,69.58,120a1.94,1.94,0,0,1,1.53.63A2,2,0,0,1,71.5,122.22Zm3.2-4.47H72.4a.41.41,0,0,0-.39.34l-.1.64-.16-.23a3.28,3.28,0,0,0-2.71-1,5.29,5.29,0,0,0-5.13,4.61,4.38,4.38,0,0,0,.86,3.53,3.6,3.6,0,0,0,2.89,1.16,4.42,4.42,0,0,0,3.18-1.31l-.11.64a.4.4,0,0,0,.4.46h2.06a.67.67,0,0,0,.66-.56l1.24-7.85A.4.4,0,0,0,74.7,117.75Z",
    style: {
      fill: "#253b80"
    }
  }), React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M86.92,117.75H84.61a.66.66,0,0,0-.55.3l-3.18,4.68-1.35-4.5a.67.67,0,0,0-.64-.48H76.63a.4.4,0,0,0-.38.53l2.54,7.46-2.39,3.37a.4.4,0,0,0,.33.63H79a.68.68,0,0,0,.55-.29l7.67-11.07A.4.4,0,0,0,86.92,117.75Z",
    style: {
      fill: "#253b80"
    }
  }), React.createElement("path", {
    id: "_Compound_Path_3",
    "data-name": "<Compound Path>",
    d: "M95.1,117.81c-.26,1.72-1.57,1.72-2.84,1.72h-.72l.5-3.21a.4.4,0,0,1,.4-.34h.33c.86,0,1.68,0,2.1.49A1.61,1.61,0,0,1,95.1,117.81Zm-.55-4.49H89.76a.67.67,0,0,0-.66.56l-1.94,12.29a.41.41,0,0,0,.4.46H90a.47.47,0,0,0,.46-.39l.55-3.48a.66.66,0,0,1,.65-.57H93.2q4.74,0,5.45-4.55a3.65,3.65,0,0,0-.61-3.09A4.43,4.43,0,0,0,94.55,113.32Z",
    style: {
      fill: "#179bd7"
    }
  }), React.createElement("path", {
    id: "_Compound_Path_4",
    "data-name": "<Compound Path>",
    d: "M105.68,122.22a2.56,2.56,0,0,1-2.59,2.19,1.91,1.91,0,0,1-1.54-.62,1.93,1.93,0,0,1-.36-1.61,2.56,2.56,0,0,1,2.57-2.21,1.94,1.94,0,0,1,1.53.63A2,2,0,0,1,105.68,122.22Zm3.19-4.47h-2.29a.4.4,0,0,0-.39.34l-.1.64-.17-.23a3.25,3.25,0,0,0-2.7-1,5.28,5.28,0,0,0-5.13,4.61,4.31,4.31,0,0,0,.86,3.53,3.6,3.6,0,0,0,2.89,1.16,4.38,4.38,0,0,0,3.17-1.31l-.1.64a.4.4,0,0,0,.4.46h2.06a.67.67,0,0,0,.66-.56l1.24-7.85A.4.4,0,0,0,108.87,117.75Z",
    style: {
      fill: "#179bd7"
    }
  }), React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M111.58,113.66l-2,12.51a.4.4,0,0,0,.4.46h2a.67.67,0,0,0,.66-.56l1.94-12.29a.4.4,0,0,0-.39-.46H112A.41.41,0,0,0,111.58,113.66Z",
    style: {
      fill: "#179bd7"
    }
  }), React.createElement("path", {
    id: "_Path_3",
    "data-name": "<Path>",
    d: "M33.09,129l.37-2.33-.82,0h-3.9l2.71-17.17a.29.29,0,0,1,.08-.14.24.24,0,0,1,.14,0h6.57c2.19,0,3.69.46,4.48,1.35a3,3,0,0,1,.71,1.34,5,5,0,0,1,0,1.86v.52l.37.21a2.63,2.63,0,0,1,.74.57,2.66,2.66,0,0,1,.61,1.36,5.62,5.62,0,0,1-.09,2,7,7,0,0,1-.8,2.23,4.54,4.54,0,0,1-1.28,1.4,5.21,5.21,0,0,1-1.72.78,8.9,8.9,0,0,1-2.16.25h-.51a1.52,1.52,0,0,0-1.52,1.3l0,.2-.64,4.11,0,.15s0,.07,0,.08a.11.11,0,0,1-.07,0Z",
    style: {
      fill: "#253b80"
    }
  }), React.createElement("path", {
    id: "_Path_4",
    "data-name": "<Path>",
    d: "M44.15,114c0,.12,0,.25-.07.38-.87,4.45-3.83,6-7.62,6H34.53a.93.93,0,0,0-.92.79l-1,6.26-.28,1.78a.49.49,0,0,0,.49.57h3.42a.83.83,0,0,0,.81-.7l0-.17.65-4.09,0-.22a.83.83,0,0,1,.81-.7h.51c3.32,0,5.91-1.34,6.67-5.23a4.44,4.44,0,0,0-.69-3.94A3.05,3.05,0,0,0,44.15,114Z",
    style: {
      fill: "#179bd7"
    }
  }), React.createElement("path", {
    id: "_Path_5",
    "data-name": "<Path>",
    d: "M43.24,113.6l-.41-.1-.43-.08a10,10,0,0,0-1.7-.13H35.55a.86.86,0,0,0-.36.08.81.81,0,0,0-.45.62l-1.1,6.94,0,.2a.93.93,0,0,1,.92-.79h1.93c3.79,0,6.75-1.54,7.62-6,0-.13.05-.26.07-.38a5.07,5.07,0,0,0-.71-.31Z",
    style: {
      fill: "#222d65"
    }
  }), React.createElement("path", {
    id: "_Path_6",
    "data-name": "<Path>",
    d: "M34.74,114a.81.81,0,0,1,.45-.62.86.86,0,0,1,.36-.08H40.7a10,10,0,0,1,1.7.13l.43.08.41.1.2.06a5.07,5.07,0,0,1,.71.31,4.19,4.19,0,0,0-.89-3.78c-1-1.12-2.75-1.6-5-1.6H31.67a1,1,0,0,0-.93.8L28,126.74a.56.56,0,0,0,.55.65h4.06l1-6.46Z",
    style: {
      fill: "#253b80"
    }
  })))))), React.createElement("g", {
    id: "Mastercard"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M259.56,141.8v.1h.09l.05,0s0,0,0,0a.05.05,0,0,0,0,0h-.14Zm.09-.07a.16.16,0,0,1,.11,0,.1.1,0,0,1,0,.09.09.09,0,0,1,0,.07.19.19,0,0,1-.09,0l.13.14h-.1l-.11-.14h0v.14h-.08v-.37Zm0,.5a.27.27,0,0,0,.12,0,.33.33,0,0,0,.1-.06.61.61,0,0,0,.07-.1.4.4,0,0,0,0-.25.36.36,0,0,0-.07-.1.21.21,0,0,0-.1-.06.27.27,0,0,0-.12,0,.24.24,0,0,0-.12,0,.17.17,0,0,0-.1.06.36.36,0,0,0-.07.1.25.25,0,0,0,0,.12.27.27,0,0,0,0,.13.61.61,0,0,0,.07.1.24.24,0,0,0,.1.06.24.24,0,0,0,.12,0m0-.72a.41.41,0,0,1,.16,0,.38.38,0,0,1,.13.09.6.6,0,0,1,.09.13.4.4,0,0,1,0,.15.41.41,0,0,1,0,.16.6.6,0,0,1-.09.13.57.57,0,0,1-.13.08.34.34,0,0,1-.32,0,.41.41,0,0,1-.13-.08.38.38,0,0,1-.09-.13.41.41,0,0,1,0-.16.4.4,0,0,1,0-.15.38.38,0,0,1,.09-.13.3.3,0,0,1,.13-.09.41.41,0,0,1,.16,0m-37.7-1.43a1.22,1.22,0,1,1,1.23,1.29,1.22,1.22,0,0,1-1.23-1.29m3.27,0v-2h-.88v.49a1.51,1.51,0,0,0-1.27-.59,2.12,2.12,0,0,0,0,4.24,1.54,1.54,0,0,0,1.27-.59v.49h.88Zm29.69,0a1.22,1.22,0,0,1,1.23-1.3,1.3,1.3,0,1,1-1.23,1.3m3.27,0v-3.65h-.88v2.12A1.5,1.5,0,0,0,256,138a2.12,2.12,0,0,0,0,4.24,1.52,1.52,0,0,0,1.27-.59v.49h.88Zm-22.05-1.34a1,1,0,0,1,1,1H235a1,1,0,0,1,1.08-1m0-.78a2.12,2.12,0,0,0,.05,4.24,2.44,2.44,0,0,0,1.66-.57l-.43-.65a2,2,0,0,1-1.18.43,1.12,1.12,0,0,1-1.2-1h3c0-.11,0-.22,0-.34a1.93,1.93,0,0,0-1.91-2.12m10.6,2.12a1.23,1.23,0,1,1,1.23,1.29,1.22,1.22,0,0,1-1.23-1.29m3.28,0v-2h-.88v.49a1.52,1.52,0,0,0-1.28-.59,2.12,2.12,0,0,0,0,4.24,1.54,1.54,0,0,0,1.28-.59v.49H250Zm-8.24,0a2,2,0,0,0,2.16,2.12,2.14,2.14,0,0,0,1.45-.48L245,141a1.83,1.83,0,0,1-1.06.36,1.3,1.3,0,0,1,0-2.59,1.77,1.77,0,0,1,1.06.37l.42-.71a2.09,2.09,0,0,0-1.45-.48,2,2,0,0,0-2.16,2.12M253.1,138a1.19,1.19,0,0,0-1.07.59v-.49h-.87v4H252v-2.27c0-.67.29-1,.87-1a1.51,1.51,0,0,1,.54.1l.28-.82a1.82,1.82,0,0,0-.63-.11m-23.55.42a3,3,0,0,0-1.65-.42c-1,0-1.68.49-1.68,1.29s.49,1.06,1.39,1.19l.42.06c.48.07.71.19.71.42s-.33.49-.93.49a2.16,2.16,0,0,1-1.34-.42l-.41.69a2.94,2.94,0,0,0,1.75.52c1.16,0,1.84-.55,1.84-1.32s-.53-1.08-1.41-1.21l-.42-.06c-.38-.05-.68-.12-.68-.39s.29-.48.77-.48a2.66,2.66,0,0,1,1.26.35Zm11.33-.42a1.18,1.18,0,0,0-1.06.59v-.49H239v4h.88v-2.27c0-.67.28-1,.86-1a1.56,1.56,0,0,1,.55.1l.27-.82a1.78,1.78,0,0,0-.63-.11m-7.49.1H232v-1.23h-.89v1.23h-.82v.8h.82v1.84c0,.94.36,1.5,1.4,1.5a2.11,2.11,0,0,0,1.1-.31l-.25-.76a1.54,1.54,0,0,1-.78.23c-.44,0-.58-.27-.58-.67v-1.83h1.44Zm-13.14,4v-2.54a1.5,1.5,0,0,0-1.59-1.6,1.56,1.56,0,0,0-1.42.71,1.5,1.5,0,0,0-1.34-.71,1.32,1.32,0,0,0-1.18.6v-.5h-.88v4h.89v-2.24a1,1,0,0,1,1-1.08c.58,0,.88.38.88,1.07v2.25h.88v-2.24a1,1,0,0,1,1-1.08c.6,0,.89.38.89,1.07v2.25Z",
    style: {
      fill: "#231f20"
    }
  }), React.createElement("path", {
    d: "M260.1,128.66v-.59H260l-.18.41-.18-.41h-.15v.59h.11v-.45l.16.39h.12l.16-.39v.45Zm-1,0v-.49h.19v-.1h-.5v.1h.2v.49Z",
    style: {
      fill: "#f79410"
    }
  }), React.createElement("path", {
    d: "M242.61,131.2H229.29V107.27h13.32Z",
    style: {
      fill: "#ff5f00"
    }
  }), React.createElement("path", {
    d: "M230.15,119.23a15.18,15.18,0,0,1,5.81-12,15.22,15.22,0,1,0,0,23.93,15.2,15.2,0,0,1-5.81-12",
    style: {
      fill: "#eb001b"
    }
  }), React.createElement("path", {
    d: "M260.57,119.23a15.23,15.23,0,0,1-24.63,12,15.21,15.21,0,0,0,0-23.93,15.22,15.22,0,0,1,24.63,12",
    style: {
      fill: "#f79e1b"
    }
  }))), React.createElement("g", {
    id: "AliPay"
  }, _ref3, React.createElement("path", {
    id: "path215",
    d: "M400.23,107.92l-1,.08s-1,.22-1,.67v1.5l-4.37.15v-.83h-2s-2,.15-2,.75v5.46h8.41v3.74h-5.79v1.49h5.79v8.56l4.3-.45v-8.11h6.17v-1.49h-6.17V115.7h7.25V115H410s.56,0,.89-.9l.34-2.46a1.84,1.84,0,0,0-1.94-1.8l-6.73.23v-2.1Zm6.65,3.44a.61.61,0,0,1,.64.6l-.3,2.28H393.88v-2.47l4.37-.11v0l4.3-.19Z",
    style: {
      fill: "#003f96"
    }
  }), React.createElement("path", {
    id: "path971",
    d: "M374.1,119.44l1.39,1.6,1.6,1.42a.62.62,0,0,0,.9,0l1.57-1.42,1.38-1.6a.62.62,0,0,0,0-.94l-1.38-1.57L378,115.55a.62.62,0,0,0-.9,0l-1.57,1.38-1.42,1.57a.73.73,0,0,0,0,.94",
    style: {
      fill: "#ec6c00"
    }
  }), React.createElement("path", {
    id: "path973",
    d: "M410,124.37a.61.61,0,0,0,0-.71l-1.09-1.2-1.19-1a.5.5,0,0,0-.71,0l-1.2,1-1.05,1.2a.56.56,0,0,0,0,.71l1.05,1.2,1.2,1a.47.47,0,0,0,.71,0l1.19-1,1.09-1.2",
    style: {
      fill: "#ec6c00"
    }
  }), React.createElement("path", {
    id: "path979",
    d: "M345.89,117.64h12.82a18.21,18.21,0,0,1-1.31,3.29,23.52,23.52,0,0,1-4.08,5.5s-4.63,4.33-7.62,4.33a8.65,8.65,0,0,1-3.63-.82,4.06,4.06,0,0,1-1.75-3.33s0-3,4.52-3.81c0,0-2.92-.19-4.45,1.35a5.34,5.34,0,0,0-1.42,3.7,4.57,4.57,0,0,0,2.06,3.58,8.35,8.35,0,0,0,4.44,1.2l.6,0a18.24,18.24,0,0,0,9.79-4.19,24.16,24.16,0,0,0,6.06-8.18,19.65,19.65,0,0,0,1-3l.23-1.16v0H356.2V112.9h8.71v-1.46H356.2V108h-2.28l-1,.07s-1,.23-1,.67v2.66h-8.41v1.46h8.41v3.29h-6.05v1.45",
    style: {
      fill: "#003f96"
    }
  }), React.createElement("path", {
    id: "path981",
    d: "M374.63,107.92l-.08.72-.48,1.75a10.28,10.28,0,0,1-1.31,2.13v16.86l-4.3-.52V115.48s-1.61.82-3,1.34l-.56-.9a25.66,25.66,0,0,0,2.92-2.43s2.87-2.87,2.87-4.82c0,0,0-.45,1-.67l1-.08h1.95",
    style: {
      fill: "#003f96"
    }
  }), React.createElement("path", {
    id: "path983",
    d: "M373.43,114.39h8.08v15.55l4.29.07V114.39h2.25V112.9H385.8v-5h-2.31l-1,.08s-1,.22-1,.67v4.23h-8.08v1.49",
    style: {
      fill: "#003f96"
    }
  }), React.createElement("path", {
    id: "path985",
    d: "M353.88,123.44s-5.45-2.4-8.82-2.51a8.86,8.86,0,0,0-5,1.46s-2.4,1.68-2.47,4.19a6,6,0,0,0,2.32,4.56,10.19,10.19,0,0,0,5.57,1.53h.33l-.56,0A8.5,8.5,0,0,1,341,131.4a4.93,4.93,0,0,1-1.94-3.67,5.06,5.06,0,0,1,1.72-3.73,7.14,7.14,0,0,1,3.81-1.09l3.33.38,2.58,1,6.16,3.14a67.27,67.27,0,0,0,8.26,3.55s14.06,4.67,45.49,1.6l1.68-.33a2.73,2.73,0,0,0,1.09-1,25,25,0,0,1,3.21-3.14s2-1.83,1.35-2.43l-1,.15a158.73,158.73,0,0,1-25.94,3s-17.6.71-26.31-1.79c0,0-6-1.72-10.58-3.51",
    style: {
      fill: "#ec6c00"
    }
  })), React.createElement("g", {
    id: "Visa"
  }, React.createElement("polygon", {
    id: "polygon9",
    points: "158.83 130.59 153.63 130.59 156.88 110.49 162.08 110.49 158.83 130.59",
    style: {
      fill: "#00579f"
    }
  }), React.createElement("path", {
    id: "path11",
    d: "M177.67,111a13,13,0,0,0-4.66-.85c-5.14,0-8.75,2.73-8.77,6.65,0,2.88,2.59,4.49,4.55,5.45s2.7,1.63,2.7,2.5c0,1.35-1.63,2-3.12,2a10.34,10.34,0,0,1-4.88-1.07l-.68-.32-.73,4.51a15.66,15.66,0,0,0,5.79,1.07c5.46,0,9-2.69,9-6.86,0-2.29-1.37-4-4.36-5.48-1.82-.92-2.93-1.54-2.93-2.48s.94-1.73,3-1.73a8.81,8.81,0,0,1,3.87.77l.47.21.71-4.34Z",
    style: {
      fill: "#00579f"
    }
  }), React.createElement("path", {
    id: "path13",
    d: "M184.58,123.47l2.07-5.62s.43-1.18.69-1.93l.36,1.73s1,4.82,1.2,5.82Zm6.41-13h-4a2.55,2.55,0,0,0-2.71,1.67l-7.72,18.43H182l1.09-3h6.67c.15.7.62,3,.62,3h4.81L191,110.49Z",
    style: {
      fill: "#00579f"
    }
  }), React.createElement("path", {
    id: "path15",
    d: "M149.29,110.49,144.2,124.2l-.56-2.78a15.41,15.41,0,0,0-7.18-8.43l4.66,17.58h5.5l8.17-20.08Z",
    style: {
      fill: "#00579f"
    }
  }), React.createElement("path", {
    id: "path17",
    d: "M139.47,110.49h-8.36l-.08.41c6.52,1.67,10.84,5.69,12.61,10.52l-1.81-9.24a2.16,2.16,0,0,0-2.36-1.69Z",
    style: {
      fill: "#faa61a"
    }
  })), React.createElement("g", {
    id: "AmericanExpress"
  }, React.createElement("path", {
    d: "M315.93,119.9h3.38V112h-3.68v1.09l-.7-1.09h-3.18v1.39l-.6-1.39h-5.87c-.2,0-.4.1-.6.1s-.3.1-.5.2-.3.1-.49.2V112H286.87l-.5,1.29-.5-1.29h-4v1.39l-.6-1.39h-3.18l-1.39,3.38v4.48H279l.39-1.1h.8l.4,1.1h17.51v-1l.7,1h4.88v-.6c.1.1.29.1.39.2s.3.1.4.2a1.27,1.27,0,0,0,.6.1h3.58l.4-1.1h.8l.39,1.1h4.88v-1Zm5.47,9.95v-7.36H294l-.69,1-.7-1h-8v7.86h8l.7-1,.69,1h5v-1.69h-.2a4.79,4.79,0,0,0,1.79-.3v2.09h3.58v-1l.7,1h14.83A8.64,8.64,0,0,0,321.4,129.85Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M319.71,128H317v1.09h2.59a1.64,1.64,0,0,0,1.79-1.69,1.39,1.39,0,0,0-1.59-1.49h-1.2a.5.5,0,0,1,0-1h2.29l.5-1.09h-2.69a1.63,1.63,0,0,0-1.79,1.59,1.4,1.4,0,0,0,1.59,1.5h1.2a.46.46,0,0,1,.5.49C320.3,127.76,320.11,128,319.71,128Zm-4.88,0h-2.69v1.09h2.59a1.64,1.64,0,0,0,1.79-1.69,1.39,1.39,0,0,0-1.59-1.49h-1.19a.5.5,0,0,1,0-1H316l.49-1.09h-2.68a1.63,1.63,0,0,0-1.79,1.59,1.39,1.39,0,0,0,1.59,1.5h1.19a.55.55,0,0,1,0,1.09Zm-3.48-3.18v-1.1h-4.18V129h4.18v-1.1h-3v-1.09h2.89v-1.1h-2.89v-1h3Zm-6.77,0c.5,0,.7.29.7.59s-.2.6-.7.6h-1.49v-1.29Zm-1.49,2.28h.6l1.59,1.9h1.49L305,127a1.58,1.58,0,0,0,1.39-1.59,1.64,1.64,0,0,0-1.79-1.69H301.8V129H303Zm-3.19-1.59a.62.62,0,0,1-.69.7h-1.59v-1.39h1.49A.7.7,0,0,1,299.9,125.47Zm-3.48-1.79V129h1.2v-1.8h1.59a1.75,1.75,0,0,0,1.89-1.79,1.73,1.73,0,0,0-1.79-1.79ZM294.63,129h1.49L294,126.27l2.09-2.59h-1.49l-1.29,1.69-1.3-1.69h-1.49l2.09,2.59-2.09,2.59H292l1.3-1.7Zm-4.48-4.18v-1.1H286V129h4.18v-1.1h-3v-1.09h2.88v-1.1h-2.88v-1h3Zm24.18-9.36,2.09,3.19h1.5v-5.28h-1.2v3.48l-.3-.49-1.89-3h-1.59v5.28h1.19V115Zm-5.17-.1.4-1.09.4,1.09.49,1.2h-1.79Zm2.09,3.29h1.29l-2.29-5.28h-1.59l-2.29,5.28h1.3l.49-1.1h2.59Zm-5.57,0,.49-1.1h-.29a1.34,1.34,0,0,1-1.4-1.49v-.1a1.33,1.33,0,0,1,1.4-1.49h1.29v-1.1h-1.39a2.38,2.38,0,0,0-2.49,2.59v.1A2.31,2.31,0,0,0,305.68,118.61Zm-4.48,0h1.19v-5.18H301.2Zm-2.59-4.18c.5,0,.7.29.7.59s-.2.6-.7.6h-1.49v-1.29Zm-1.49,2.28h.59l1.6,1.9h1.49l-1.79-2a1.6,1.6,0,0,0,1.39-1.6,1.64,1.64,0,0,0-1.79-1.69h-2.79v5.28H297Zm-2.19-2.28v-1.1h-4.18v5.28h4.18v-1.1h-3v-1.09h2.89v-1.1h-2.89v-1h3Zm-9.06,4.18H287l1.49-4.28v4.28h1.19v-5.28h-2l-1.19,3.58-1.19-3.58h-2v5.28h1.19v-4.28Zm-6.47-3.29.4-1.09.4,1.09.5,1.2h-1.79Zm2.09,3.29h1.3l-2.29-5.28H279l-2.29,5.28H278l.5-1.1h2.59Z",
    style: {
      fill: "#006fcf"
    }
  })), React.createElement("g", {
    id: "WeChatPay"
  }, React.createElement("g", null, React.createElement("path", {
    id: "_Path_7",
    "data-name": "<Path>",
    d: "M453.52,108.07H456a1.34,1.34,0,0,0,0,.2C455.17,108.16,454.35,108.1,453.52,108.07Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    id: "_Path_8",
    "data-name": "<Path>",
    d: "M443.21,120.84c0-.24,0-.49,0-.74a1,1,0,0,1,.35.15l.82.59",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    id: "_Path_9",
    "data-name": "<Path>",
    d: "M447.87,129l.43,0-.4.24A1.24,1.24,0,0,1,447.87,129Z",
    style: {
      fill: "#fff"
    }
  })), React.createElement("path", {
    id: "_Path_10",
    "data-name": "<Path>",
    d: "M440.9,137.18l.17-.11c0,.2-.1.39-.15.58A1.87,1.87,0,0,1,440.9,137.18Z",
    style: {
      fill: "#eee"
    }
  }), React.createElement("path", {
    id: "_Path_11",
    "data-name": "<Path>",
    d: "M450.12,108.07h2.29c-.71,0-1.41.07-2.12.16Z",
    style: {
      fill: "#fcfffd"
    }
  }), React.createElement("path", {
    id: "_Path_12",
    "data-name": "<Path>",
    d: "M444.74,139.39l-.39.22-1.15.66-.5.3-.65.37c-.4.22-.78.46-1.19.67a.65.65,0,0,1-.74-.32.92.92,0,0,1,0-.71c.1-.38.2-.77.31-1.15s.2-.77.31-1.16c.05-.2.11-.41.16-.62s.11-.38.15-.58a1.42,1.42,0,0,0-.15-.76,1.49,1.49,0,0,0-.38-.41l-.8-.62-.6-.51-.54-.49c-.23-.23-.46-.46-.68-.7s-.34-.38-.5-.58-.31-.37-.46-.56-.46-.63-.68-1l-.13-.2c-.23-.37-.45-.75-.65-1.14s-.27-.56-.4-.84L435,129c-.16-.39-.3-.79-.42-1.19s-.21-.75-.29-1.13-.15-.78-.19-1.17a13.23,13.23,0,0,1,.05-3.5c.06-.38.12-.76.21-1.13a11.59,11.59,0,0,1,.33-1.15c.12-.39.28-.78.44-1.16v0c.18-.38.36-.77.56-1.14a15.6,15.6,0,0,1,1.56-2.31l.21-.25c.26-.31.53-.61.82-.9l.31-.31c.3-.29.6-.57.92-.83l.27-.23a19.11,19.11,0,0,1,2.3-1.58l.95-.53.22-.11c.38-.19.77-.36,1.16-.53a20.41,20.41,0,0,1,2.31-.82c.42-.12.83-.23,1.26-.33s.7-.15,1.05-.21.85-.14,1.28-.19c.71-.09,1.41-.13,2.12-.16h1.11c.83,0,1.65.09,2.47.2.38,0,.77.11,1.15.18s.77.16,1.16.25.77.19,1.16.31a21.7,21.7,0,0,1,2.33.86c.39.17.77.36,1.15.54l0,0c.38.2.76.41,1.13.63a20,20,0,0,1,2.33,1.65l.06.05c.36.32.73.64,1.07,1l.17.18c.28.27.53.57.79.87l-.45.2-.52.23-1.13.5-1,.45-.15.07-1.16.51-2.33,1-2.31,1-1.16.51-.72.33-.44.19-1.18.53-.95.42-.2.09-1.16.52-2.33,1-1.77.8a2.72,2.72,0,0,1-.55.18,1.93,1.93,0,0,1-1.14-.14,2.07,2.07,0,0,1-.25-.15l-.9-.64L446,122l-.43-.31-1.13-.8,0,0-.82-.59a1,1,0,0,0-.35-.15.66.66,0,0,0-.67.78c.33.77.69,1.52,1,2.28l.54,1.19.21.47c.11.23.21.45.31.68s.35.76.53,1.15l.33.73c.07.15.13.29.2.43a7.31,7.31,0,0,0,.61,1.22,1.68,1.68,0,0,0,.37.27,1.31,1.31,0,0,0,1.23-.05l.4-.24.73-.42,2.32-1.34,1-.58.16-.1,1.16-.66.66-.38.51-.3,1.15-.66.35-.21c.28-.15.55-.31.82-.47l2.32-1.34.89-.51.26-.15,1.16-.67.6-.35.55-.32,2.35-1.35,1.1-.64.08,0,1.15-.66.81-.47.33-.19c.37-.2.72-.43,1.1-.61.13.27.3.52.44.79a13.07,13.07,0,0,1,.58,1.19c.05.11.1.23.14.34.11.27.21.54.3.82a11,11,0,0,1,.32,1.12c.09.38.16.77.22,1.16a12.36,12.36,0,0,1,.13,2.33c0,.39,0,.77-.08,1.16s-.11.77-.19,1.15-.17.76-.29,1.14a14.4,14.4,0,0,1-.94,2.35,15.64,15.64,0,0,1-1.47,2.32l-.3.38-.65.75c-.16.17-.32.34-.49.5s-.49.47-.74.7l-.4.34c-.33.28-.68.55-1,.8l-.15.11c-.39.27-.77.52-1.17.76l-.47.27-.68.37c-.38.2-.77.38-1.17.55l-.55.23-.63.24c-.37.14-.75.26-1.13.38s-.8.23-1.21.32-.69.16-1,.23h-.08l-1.16.19c-.39,0-.77.09-1.16.12s-.77.05-1.16.06H452.5l-1.17-.06-1.15-.11-1-.16-.38-.06-.89-.2c-.4-.09-.79-.19-1.18-.3a1.92,1.92,0,0,0-1.16.07",
    style: {
      fill: "#00c800"
    }
  }), React.createElement("path", {
    id: "_Path_13",
    "data-name": "<Path>",
    d: "M456,108.07h1.17v.38c-.38-.07-.77-.13-1.15-.18A1.34,1.34,0,0,1,456,108.07Z",
    style: {
      fill: "#eeeeef"
    }
  }), React.createElement("path", {
    id: "_Path_14",
    "data-name": "<Path>",
    d: "M461.86,120.85a1.9,1.9,0,0,1,.53,0l-.6.35C461.81,121.1,461.75,120.93,461.86,120.85Z",
    style: {
      fill: "#edefef"
    }
  }), React.createElement("path", {
    id: "_Path_15",
    "data-name": "<Path>",
    d: "M456,124.35h.33l-.35.21C456,124.5,456,124.42,456,124.35Z",
    style: {
      fill: "#d9ebd7"
    }
  }), React.createElement("path", {
    id: "_Path_16",
    "data-name": "<Path>",
    d: "M437.42,133c.16.2.33.39.5.58a1,1,0,0,1-.48,0A1.61,1.61,0,0,1,437.42,133Z",
    style: {
      fill: "#fffdff"
    }
  }), React.createElement("path", {
    id: "_Path_17",
    "data-name": "<Path>",
    d: "M442.7,140.57l.5-.3v.31Z",
    style: {
      fill: "#f8fffd"
    }
  }))), React.createElement("circle", {
    id: "Right-ring",
    cx: 398,
    cy: 254,
    r: 11,
    style: {
      fill: "none",
      stroke: "#6a7bff",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    }
  }), React.createElement("circle", {
    id: "Right-ring-left",
    cx: 366,
    cy: 277,
    r: 11,
    style: {
      fill: "none",
      stroke: "#6a7bff",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    }
  }), React.createElement("circle", {
    id: "Mid-ring-bottom",
    cx: 151,
    cy: 258,
    r: 11,
    style: {
      fill: "none",
      stroke: "#6a7bff",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    }
  }), React.createElement("circle", {
    id: "Mid-ring-up",
    cx: 166,
    cy: 229,
    r: 11,
    style: {
      fill: "none",
      stroke: "#6a7bff",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    }
  }), React.createElement("circle", {
    id: "Left-ring-bottom",
    cx: 99,
    cy: 274,
    r: 11,
    style: {
      fill: "none",
      stroke: "#6a7bff",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    }
  }), React.createElement("circle", {
    id: "Left-ring",
    cx: 77,
    cy: 248,
    r: 11,
    style: {
      fill: "none",
      stroke: "#6a7bff",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDottedWorldMapMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dotted-world-map-mobile.3adf17b0.svg";
export { ForwardRef as ReactComponent };